import {BasicProps} from "../Main";
import {Grid} from "@mui/material";
import {SamaggiTypography} from "../Components/SamaggiTypography";
import {SSOButton} from "../Components/SSOButton";
import React, {useEffect} from "react";

export const SignIn: React.FC<BasicProps> = (props) => {

    useEffect(() => {
        props.setShowCover(false); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <Grid container direction={"column"} spacing={4}>
                <Grid item container direction={"column"} spacing={1}>
                    <Grid item>
                        <SamaggiTypography bold large center>Sign In to Continue</SamaggiTypography>
                    </Grid>
                    <Grid item>
                        <SamaggiTypography center>Please sign in to access the Staff Portal.</SamaggiTypography>
                    </Grid>
                </Grid>
                <Grid item>
                    <SSOButton/>
                </Grid>
            </Grid>
        </>
    )
}